/**
 * Links into the planning repository on GitLab — the project page, a file at `main`, a merge
 * request, a commit. Message-free so any room's chunk may import it (the docs reader's link
 * resolution lives in `pages/docs/links.ts` and builds on these). The default project is the
 * production one; a page that knows the server's project (every URL the API builds carries it,
 * `repoUrlOf`) passes it instead, so review apps and tests link to their own GitLab.
 */
export const REPO_URL = 'https://gitlab.codingame.com/coderpad/brain-project-planning';
/** The repository on GitLab, for the files the app has no page for (JSON datasets, CSS, scripts). */
export const REPO_BLOB_URL = `${REPO_URL}/-/blob/main/`;

/** A merge request of the repository: `!42` → its page on GitLab. */
export function repoMrUrl(iid: number | string, repoUrl: string = REPO_URL): string {
  return `${repoUrl.replace(/\/+$/, '')}/-/merge_requests/${iid}`;
}

/** A commit of the repository by SHA → its page on GitLab. */
export function repoCommitUrl(sha: string, repoUrl: string = REPO_URL): string {
  return `${repoUrl.replace(/\/+$/, '')}/-/commit/${sha}`;
}

/** The project URL behind a GitLab blob / commit / merge-request URL the server built (`…/<project>/-/blob/<sha>/…` → `…/<project>`), or null when it is not one. */
export function repoUrlOf(url: string | null | undefined): string | null {
  if (!url) return null;
  const i = url.indexOf('/-/');
  return i > 0 ? url.slice(0, i) : null;
}
